import type { ChipProps } from '@usealloy/component-library';
import { Box, Chip } from '@usealloy/component-library';
import styled, { css } from 'styled-components';


export const OptionGroup = styled(Box)`
  && {
    align-items: flex-start;
    flex-direction: column;
    font-size: var(--cl-font-size-2);
    gap: var(--cl-space-3);
  }
`;

export const PopoverContainer = styled(Box)`
  && {
    align-items: flex-start;
    flex-direction: column;
    gap: var(--cl-space-5);
    padding: var(--cl-space-4);
  }
`;

export const PopoverContent = styled(Box)`
  && {
    flex-direction: column;
    gap: var(--cl-space-4);
  }
`;

export const PopoverFooter = styled(Box)`
  && {
    justify-content: flex-end;
    gap: var(--cl-space-2);
  }
`;

export const StyledBox = styled(Box)`
  && {
    justify-content: flex-start;
    gap: var(--cl-space-4);
  }
`;

export const AxisConfigTrigger = styled.div`
  border-radius: var(--cl-radius-1);

  &:focus {
    outline: none;
    background-color: var(--cl-yellow-200);
  }
`;

interface StyledChipProps extends ChipProps {
  hasIcon?: boolean;
}
export const StyledChip = styled(Chip)<StyledChipProps>(({
  hasIcon = false,
}) => css`
  && {
    margin: 0;
    ${hasIcon
    ? css`padding: var(--cl-space-1) var(--cl-space-1-5);`
    : css`padding: var(--cl-space-2) var(--cl-space-1-5);`}
    white-space: pre;
  }
`);
